import React, { Component } from "react";
import { CharacterSelect, CharacterSelectScreen } from "./components/CharacterSelect";
import { CameraMode } from "./components/CameraMode";
import { Character, CharacterItemSelector } from "../components/characters/CharacterItemSelector";
import { BaseCharacter } from "../components/characters/BaseCharacter";
import characterImage from "../../assets/images/characters/character.svg";
import html2canvas from "html2canvas";
import { CharacterItemId } from "../components/characters/CharacterItem";
import landingFooterImage from "../../assets/images/landing-footer.png";
import landingSun from "../../assets/images/sun.png";
import { CloseButton } from "../components/CloseButton";
import { SunAnimation } from "../components/animations/SunAnimation";
import { PlaneAnimation } from "../components/animations/PlaneAnimation";
import { BeeAnimation } from "../components/animations/BeeAnimation";

export interface MeetTheCharactersScreenProps
{
}

interface MeetTheCharactersScreenState 
{
    screen: Screen;
    characterImage: string;
    selectedCharacter: Character;
    defaultCharacterSelectScreen: CharacterSelectScreen;
}

enum Screen 
{
    Loading,
    CharacterSelect,
    CameraMode,
    CameraPermissionDenied
}

export class MeetTheCharactersScreen extends Component<MeetTheCharactersScreenProps, MeetTheCharactersScreenState>
{
    private characterItemSelector: CharacterItemSelector;

    constructor(props: MeetTheCharactersScreenProps)
    {
        super(props);

        this.characterItemSelector = new CharacterItemSelector(BaseCharacter.items);

        this.state = {
            screen: Screen.CharacterSelect,
            characterImage: null,
            selectedCharacter: null,
            defaultCharacterSelectScreen: null
        };
    }

    public componentDidMount(): void
    {
        this.onCloseCameraModeClicked();
    }

    private onCloseCameraModeClicked(): void 
    {
        this.setState({
            screen: Screen.CharacterSelect
        });
    }

    private onCharacterPicked(character: Character): void 
    {
        this.setState({
            screen: Screen.Loading
        });

        let div: HTMLDivElement = document.getElementById("characterContainer") as HTMLDivElement;

        // Capture the source <div> element as an image using html2canvas
        html2canvas(div, {
            backgroundColor: "transparent",
            scale: 0.95
        }).then(canvas =>
        {
            // Get the data URL of the captured image
            const dataURL = canvas.toDataURL('image/png');

            this.setState({
                screen: Screen.CameraMode,
                characterImage: dataURL,
                selectedCharacter: character,
            });
        });
    }

    private onEditCharacterClicked(): void 
    {
        this.setState({
            defaultCharacterSelectScreen: CharacterSelectScreen.DressCharacter,
            screen: Screen.CharacterSelect
        });
    }

    public render(): JSX.Element
    {
        return (
            <>
                {
                    (() => 
                    {
                        switch (this.state.screen)
                        {
                            case Screen.Loading:
                                return (
                                    <>
                                        <CloseButton onClicked={this.onCloseCameraModeClicked.bind(this)} />

                                        <div className="screen-meetthecharacters loading">
                                            <div className="landing-screen">
                                                <div className="sun">
                                                    <SunAnimation />
                                                </div>
                                                <div className="container">
                                                    <div className="landing-container">

                                                        <h2 className="sub-title text-uppercase text-center">
                                                            Loading, please wait
                                                        </h2>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                );

                            case Screen.CharacterSelect:
                                return (
                                    <CharacterSelect
                                        onCharacterPicked={this.onCharacterPicked.bind(this)}
                                        characterItemSelector={this.characterItemSelector}
                                        defaultScreen={this.state.defaultCharacterSelectScreen}
                                        defaultCharacter={this.state.selectedCharacter}
                                    />
                                );

                            case Screen.CameraMode:
                                return (
                                    <CameraMode
                                        characterImage={this.state.characterImage}
                                        onClose={this.onCloseCameraModeClicked.bind(this)}
                                        onEdit={this.onEditCharacterClicked.bind(this)}
                                    />
                                );
                        }
                    })()
                }
            </>
        );
    }
}